import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "var(--font-family)",
  },
  palette: {
    primary: {
      main: "#1f3564", //blue remax
    },
  },
});

export default theme;
